import { render, staticRenderFns } from "./last_commit.vue?vue&type=template&id=4243a24c&scoped=true&"
import script from "./last_commit.vue?vue&type=script&lang=js&"
export * from "./last_commit.vue?vue&type=script&lang=js&"
import style0 from "./last_commit.vue?vue&type=style&index=0&id=4243a24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243a24c",
  null
  
)

export default component.exports